module.exports = __webpack_public_path__ + "img/6.5455c327.jpg";